module.exports = __webpack_public_path__ + "static/media/fishing.75f2aa6a.webp";